export default "__VITE_ASSET__BcLEvspr__"